'use client'

import { FC, ReactNode } from 'react'
import { useGetTranslations } from '@/root/shared-hooks'
import type { Key } from '@/root/shared-hooks/useGetTranslations/useGetTranslations'
import { ClockIcon } from '@/root/ui/shared/icons/ClockIcon'
import { TicketsIcon } from '@/root/ui/shared/icons/TicketsIcon'
import { CustomerInfoIcon } from '@/root/ui/shared/icons/CustomerInfoIcon'
import cn from 'classnames'
import { EDIT_TABS, type EditReservationTab } from '@/root/modules/shared/EditReservation/consts'
import { testIds } from '@/root/shared-consts'

interface EditReservationTabsProps {
  activeTab: EditReservationTab
  onTabChange: (tab: EditReservationTab) => void
}

const TABS: { id: EditReservationTab; labelKey: Key; testId: string; renderIcon: (isActive: boolean) => ReactNode }[] = [
  { id: EDIT_TABS.ROUTE, labelKey: 'editReservationTab', testId: testIds.edit.tabRoute, renderIcon: (isActive) => <ClockIcon width={20} height={20} color={isActive ? 'white' : 'neutral-darkest'} /> },
  { id: EDIT_TABS.TICKETS, labelKey: 'travelDataTab', testId: testIds.edit.tabTickets, renderIcon: (isActive) => <TicketsIcon width={16} height={20} color={isActive ? 'white' : undefined} /> },
  { id: EDIT_TABS.CUSTOMER, labelKey: 'additionalServicesTab', testId: testIds.edit.tabCustomer, renderIcon: (isActive) => <CustomerInfoIcon width={16} height={20} color={isActive ? 'white' : undefined} /> },
]

export const EditReservationTabs: FC<EditReservationTabsProps> = ({ activeTab, onTabChange }) => {
  const { getTranslation } = useGetTranslations()

  return (
    <div className="flex flex-wrap justify-center gap-2 md:justify-start">
      {TABS.map((tab) => {
        const isActive = activeTab === tab.id
        return (
          <button
            key={tab.id}
            data-testid={tab.testId}
            onClick={() => onTabChange(tab.id)}
            className={cn(
              'flex h-12 items-center justify-center gap-2 rounded-full px-5',
              'text-base leading-normal font-medium whitespace-nowrap transition-colors duration-300 focus:outline-none',
              isActive ? 'bg-base-medium-light text-white' : 'text-gray-500'
            )}
            type="button"
          >
            {tab.renderIcon(isActive)}
            <span>{getTranslation(tab.labelKey)}</span>
          </button>
        )
      })}
    </div>
  )
}
